import type { NitroFetchOptions, NitroFetchRequest } from 'nitropack';

type SubmitOptions = NitroFetchOptions<NitroFetchRequest, 'patch' | 'post' | 'put' | 'delete'> & {
  showSnackbar?: boolean;
  skipAuth?: boolean;
};

export function useSubmit<T, Error = unknown>() {
  const pending = ref(false);
  const data = ref<T>();
  const error = ref<Error>();
  const { $api } = useNuxtApp();

  async function execute(request: NitroFetchRequest, opts?: SubmitOptions | undefined) {
    try {
      error.value = undefined;
      pending.value = true;
      const response = await $api<T>(request, {
        ...opts,
        showSnackbar: opts?.showSnackbar ?? true,
      });
      data.value = response as T;
    } catch (e) {
      error.value = e as Error;
    } finally {
      pending.value = false;
    }
  }

  return {
    pending,
    data,
    error,
    execute,
  };
}
